import axios from 'axios';

const CHECK_URL = '/rest/auth/v1/check';
const POLL_INTERVAL_MS = 60_000;
const SYNC_EVENT = 'connectionSyncChanged';

let intervalId = null;

function authHeaders() {
    const token     = localStorage.getItem('userAuthToken');
    const sessionId = localStorage.getItem('userSessionId');
    return {
        ...(token     ? { 'X-Token': token }          : {}),
        ...(sessionId ? { 'X-Session-Id': sessionId } : {}),
    };
}

// Match the basename used by <BrowserRouter> in src/App.js so the admin-page
// check works when the app is mounted under a subpath (e.g. /auditHippo).
const BASENAME = (process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL || '').replace(/\/$/, '');

function appPathname() {
    const p = window.location.pathname;
    if (BASENAME && p.startsWith(BASENAME)) {
        return p.slice(BASENAME.length) || '/';
    }
    return p;
}

function isUserSession() {
    // Connection-status polling is a user-session concern.
    // Skip on admin pages (admins don't have an assigned connection).
    if (appPathname().startsWith('/admin')) return false;
    return localStorage.getItem('isLoggedIn') === 'true'
        && !!localStorage.getItem('userAuthToken');
}

async function pingOnce() {
    if (!isUserSession()) return;
    try {
        const res  = await axios.get(CHECK_URL, { headers: authHeaders() });
        const data = res.data || {};
        const status = data.connectionSyncStatus || data.syncStatus || '';
        if (status) {
            const prev = localStorage.getItem('userConnectionSyncStatus');
            localStorage.setItem('userConnectionSyncStatus', status);
            if (prev !== status) {
                window.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: { status } }));
            }
        }
    } catch (err) {
        // 401 + 403/connectionDeactivated are handled by the global axios interceptor.
        // Any other error: just log and try again on the next tick.
        if (err.response?.status && err.response.status !== 401 && err.response.status !== 403) {
            console.warn('[connectionPoll] check failed:', err.response.status, err.response?.data, err.message);
        }
    }
}

function startConnectionPoll() {
    if (intervalId) return;
    pingOnce();
    intervalId = setInterval(pingOnce, POLL_INTERVAL_MS);
}

function stopConnectionPoll() {
    if (!intervalId) return;
    clearInterval(intervalId);
    intervalId = null;
}

// Auto-start when this module is imported.
startConnectionPoll();

// Re-evaluate when the tab regains focus (catches sessions that died while the tab was hidden).
window.addEventListener('focus', () => {
    if (isUserSession()) pingOnce();
});

export { startConnectionPoll, stopConnectionPoll, pingOnce, SYNC_EVENT };
